module.exports = __webpack_public_path__ + "static/media/RelishConnect.db65e156.png";